import logo from './logo.svg';
import './App.css';
import Displaydata from './Components/DisplayData/Displaydata';

function App() {
  return (
    <div>
      <Displaydata> </Displaydata>
    </div>
  );
}

export default App;
